import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import images from "../assets/images";
import {useTranslation} from "react-i18next";

interface OmwaAccessModalProps{
    isOpen: boolean;
    onClose: () => void;
    onFindOutMore: () => void;
}

const OmwaAccessModal: React.FC<OmwaAccessModalProps> = (props: OmwaAccessModalProps) => {
    const { t } = useTranslation();
    return (
        <Transition appear show={props.isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={() => undefined}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black/25" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel
                                className="w-full max-w-lg transform overflow-hidden rounded-xl bg-white p-6 align-middle shadow-xl transition-all">
                                <Dialog.Title
                                    className="text-lg font-bold text-secondary justify-center text-center"
                                >
                                    {t('MODAL.OMWA_UNLOCK_MODAL_TITLE')}
                                </Dialog.Title>
                                <img
                                    src={images.omwa_dialog_logo}
                                    alt="logo"
                                    className="h-36 w-36 mx-auto mt-4"
                                />
                                <div className="mt-8">
                                    <p className="font-normal text-sm text-neutral-600">
                                        {t('MODAL.OMWA_UNLOCK_MODAL_DESC_1')}
                                    </p>
                                </div>

                                <div className="mt-4">
                                    <p className="font-normal text-sm text-neutral-600 font-sans">
                                        {t('MODAL.OMWA_UNLOCK_MODAL_DESC_2')}
                                    </p>
                                </div>

                                <div className="mt-8 flex justify-between">
                                    {/* Left-side outlined button */}
                                    <button
                                        type="button"
                                        className="text-sm text-neutral-800 inline-flex w-full mr-2 justify-center rounded-full border border-neutral-200 bg-white px-4 py-2 font-bold"
                                        onClick={props.onClose}
                                    >
                                        {t('MODAL.OMWA_UNLOCK_MODAL_BTN_1')}
                                    </button>
                                    {/* Right-side solid button */}
                                    <button
                                        type="button"
                                        className="font-sans font-bold inline-flex w-full ml-2 justify-center rounded-full border border-transparent bg-primary px-4 py-2 text-sm text-white hover:bg-emerald-800"
                                        onClick={props.onFindOutMore}
                                    >
                                        {t('MODAL.OMWA_UNLOCK_MODAL_BTN_2')}
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
};

export default OmwaAccessModal;